import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { MultimediaManagerDialogLayoutService } from '../multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.service';
import { MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-multimedia-manager-dialog-item-multimedia',
  templateUrl: './multimedia-manager-dialog-item-multimedia.component.html',
  styleUrls: ['./multimedia-manager-dialog-item-multimedia.component.scss']
})
export class MultimediaManagerDialogItemMultimediaComponent implements OnInit, OnChanges {

  @Input() item;
  webscript;
  weburl;

  constructor(private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.item) {
      switch (this.item.Type) {
        case MultimediaManagerDialogItemTypes.WEB_SCRIPT:
          this.sanitizeWebscript(this.item.Url);
        break;
        case MultimediaManagerDialogItemTypes.WEB_URL:
          this.sanitizeWeburl(this.item.Url);
        break;
      }
    }
  }

  private sanitizeWebscript(webscript) {
    this.webscript = this.sanitizer.bypassSecurityTrustHtml(webscript);
  }

  private sanitizeWeburl(weburl) {
    this.weburl = this.sanitizer.bypassSecurityTrustResourceUrl(weburl);
  }

  public selectItem() {
    this.item.Selected = !this.item.Selected;
  }

  public showDetails(e) {
    this.multimediaManagerDialogLayoutService.showDetails(this.item);
    e.stopPropagation();
  }

  public getTypeIcon() {
    switch (this.item && this.item.Type) {
      case MultimediaManagerDialogItemTypes.IMAGE_FILE:
        return 'fas fa-file-image';
      case MultimediaManagerDialogItemTypes.IMAGE_URL:
        return 'fas fa-image';
      case MultimediaManagerDialogItemTypes.VIDEO_FILE:
        return 'fas fa-video';
      case MultimediaManagerDialogItemTypes.VIDEO_URL:
        return 'fas fa-video';
      case MultimediaManagerDialogItemTypes.VIDEO_YOUTUBE:
        return 'fab fa-youtube';
      case MultimediaManagerDialogItemTypes.WEB_SCRIPT:
        return 'fas fa-laptop-code';
      case MultimediaManagerDialogItemTypes.WEB_URL:
        return 'fas fa-link';
    }
  }
}
